import { createBrowserRouter, Outlet, RouterProvider } from "react-router";
import { RootRouter } from "../../app";
import { MainMenu } from "../config/data.types";
import store from "../store"
import { statusAppController } from "../modulos/root/root.controller";
import { startRouterPaciente } from "../modulos/paciente/paciente.router";
import { startRouterAtendimento } from "../modulos/atendimento/atendimento.router";
import { startRouterCentralConfig  } from "../modulos/centralConfig/central.router";
import { startRouterPainel } from "../modulos/painel/painel.router";

export const AninharView = Outlet;
export const menuRotas: MainMenu[] = [];

const WrapperRootPage = () => {
/*     return (
         <RequireAuth>
            <RootRouter />
        </RequireAuth> 
    ) */
}

export const rotas = createBrowserRouter([

    {
        path:"/",
        element:<RootRouter />,
        children:[
            startRouterPaciente(),
            startRouterAtendimento(),
            startRouterCentralConfig(),
        ]
    }
])



export const Roteador = () => {
    console.log("Iniciou o roteador.")
    rotas.navigate("/")
    store.dispatch(statusAppController.reducer.actions.startApp());
    return (
        <RouterProvider router={rotas} />
    )
}